module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-07.51c45600.jpg";